import { render } from "./BackorderTable.vue?vue&type=template&id=6ae72546&scoped=true"
import script from "./BackorderTable.vue?vue&type=script&lang=js"
export * from "./BackorderTable.vue?vue&type=script&lang=js"

import "./BackorderTable.vue?vue&type=style&index=0&id=6ae72546&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae72546"]])

export default __exports__